export const NULL_SPEC_PARAMS = {
  id: null,
  add_date: null,
  add_by: null,
  required: null,
  required_on: null,
  doc_id: null,
  doc_part: null,
  classifiers: [],
  features: [],
  status: null,
};

export const REQUIREMENT_UPDATE_KEYS = [
  'requirements_relations_attributes',
  'document_section_id',
  'hidden',
  'status',
  'position',
  'document_id',
  'mandatory',
  'voluntary',
  'mandatory_documents',
  'voluntary_documents',
  'elements_id',
  'requirements_text_ids',
  'application_area',
];
